module.exports = __webpack_public_path__ + "static/media/math_maverick.21c32709.svg";